import { apiClient } from './client'
import type { QuizScript } from '@quebon/shared-learning'

export const quizScriptApi = {
  getContentQuizzes: async (
    contentId: number,
    location?: 'pre' | 'post' | 'checkup' | 'wrapup' | 'aiq',
    showAnswer = false,
    useFixedVars = true,
    includeSolveResult = false
  ): Promise<QuizScript[]> => {
    const response = await apiClient.get(
      `/quiz/contents/${contentId}/quizzes`,
      { params: { location, showAnswer, useFixedVars, includeSolveResult } }
    )
    return response.data.data
  },

  getQuizzes: async (
    ids: string[],
    showAnswer = false,
    useFixedVars = true
  ): Promise<QuizScript[]> => {
    const response = await apiClient.get('/quiz/quizzes', {
      params: { ids: ids.join(','), showAnswer, useFixedVars },
    })
    return response.data.data
  },
}
